module.exports = __webpack_public_path__ + "img/arrow-dw-big.91eee3d1.svg";